import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyB20L5OtUm0zFZwddXHsiu4gkQ7xdNZms8",
    authDomain: "cloudidi.firebaseapp.com",
    projectId: "cloudidi",
    storageBucket: "cloudidi.appspot.com",
    messagingSenderId: "922055457550",
    appId: "1:922055457550:web:4b850756cddfe1a178355f"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Make db and auth references
export const db = firebase.firestore()
export const auth = firebase.auth()